import React from 'react';
import {observer} from 'mobx-react';
import {LinkButton} from '@vidazoo/ui-kit';
import useReportingModel from '../../common/hooks/useReportingModel';
import theme from '../../view/theme.module.scss';

/** Shown only while rows are compared to a baseline row; otherwise renders nothing. */
function BaselineBar(): React.JSX.Element {
    const model = useReportingModel();
    const row = model.baselineRow;
    if (!row) return null;

    const name = row.groups.map((group) => group.value || '-').join(' · ');

    return (
        <div className={theme.baselineBar} role="status">
            <span className={theme.baselineMarker} aria-hidden="true"/>
            <span className={theme.baselineText}>
                Comparing all rows to <strong>{name}</strong>
                <span className={theme.baselineHint}> · ▲ / ▼ show the change from this row</span>
            </span>
            <LinkButton type="button" small uppercase spaced bold deepPurple iconName="icon-cancel-small"
                        onClick={model.clearBaselineRow}>
                Stop comparing
            </LinkButton>
        </div>
    );
}

export default observer(BaselineBar);
